import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './saas_v2/Header';
import Footer from './saas_v2/Footer';
import Home from './saas_v2/Home';
import Modules from './saas_v2/Modules';
import Status from './saas_v2/Status';
import Pricing from './saas_v2/Pricing';

export default function SaaSTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#0A0E14]" data-testid="mc-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }} data-testid={`mc-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'modules' && <Modules setPage={setPage} />}
          {page === 'status' && <Status setPage={setPage} />}
          {page === 'pricing' && <Pricing setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
